import type { TRuleWithTheme } from '@ackee/fela';

export const container: TRuleWithTheme = ({}) => ({
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
});

export const link: TRuleWithTheme = ({ theme: { colors, transition } }) => ({
    color: colors.lightGrey,
    fontWeight: '500',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    textDecoration: 'none',

    transition,
    transitionProperty: 'color',

    ':hover': {
        color: colors.fuchsia,
    },
});

export const photo: TRuleWithTheme = ({}) => ({
    height: '2rem',
    marginRight: '0.5rem',
});
